import React from "react";
import { Link } from "@bloomberg/media-ui-article";
import { createClasses } from "@bloomberg/media-ui-core";
import { NewWindow } from "@bloomberg/media-ui-icons";
import { useRegUIClient } from "@foundation/reg-ui-client";

import styles from "./styles.module.css";

export type ShareFeedbackProps = {
    feedbackUrl: string;
    storySlug: string;
    className?: string;
};

export default function ShareFeedback({
    feedbackUrl,
    storySlug,
    className,
}: ShareFeedbackProps) {
    const { session } = useRegUIClient();
    const bConnectId = session?.userInfo?.userId;
    const feedbackSurveyUrl = `${feedbackUrl}?slug=${storySlug}${
        bConnectId ? `&bconnectId=${bConnectId}` : ""
    }`;

    const shareFeedbackClass = createClasses(
        styles.shareFeedbackContainer,
        className
    );

    return (
        <div className={shareFeedbackClass}>
            <Link href={feedbackSurveyUrl} target="_blank">
                <span className={styles.shareFeedbackCopy}>Site feedback:</span>
                <div className={styles.shareFeedbackLink}>
                    <span className={styles.shareFeedbackText}>
                        Take our Survey
                    </span>
                    <NewWindow />
                </div>
            </Link>
        </div>
    );
}
